<template>
  <!-- Site Audio Broadcast 전송 상태 알약. App.vue 에 한 번만 두는 전역 표시다 —
       모달 안에 있을 때는 전송 중에 모달을 닫으면 결과(Sent/Failed)를 못 봤다.
       전송 상태는 스토어(statusSendSiteTTS)에 있으므로 모달과 무관하게 따라간다. -->
  <div class="broadcast-status" :class="{ sending: isTalkdownSending }">
    <div class="status-pill" :class="[{ success: isSuccessSending }, { failed: isFailedSending }]">
      <MyIcon v-if="isSuccessSending" v-bind:icon="'check_animation'" v-bind:width="24" />
      <MyIcon v-else-if="isFailedSending" v-bind:icon="'x_animation'" v-bind:width="16" />
      <ion-spinner v-else name="crescent" color="light" class="status-spinner"></ion-spinner>
      <span class="status-text">{{ statusText }}</span>
    </div>
  </div>
</template>

<script>
import MyIcon from '@/components/MyIcon'
export default {
  name: 'broadcast-status-pill',
  components: {
    MyIcon,
  },
  computed: {
    statusSendSiteTTS: function () {
      return this.$store.getters.statusSendSiteTTS
    },
    statusText: function () {
      if (this.isSuccessSending) return 'Sent'
      if (this.isFailedSending) return 'Failed'
      return 'Sending…'
    },
  },
  data: function () {
    return {
      isTalkdownSending: false,
      isSuccessSending: false,
      isFailedSending: false,
    }
  },
  watch: {
    statusSendSiteTTS: function () {
      if (this.statusSendSiteTTS === null) return
      if (this.statusSendSiteTTS === '') return
      if (this.statusSendSiteTTS === undefined) return
      if (this.statusSendSiteTTS == 'requested') this.onTalkdownRequested()
      if (this.statusSendSiteTTS == 'successful') this.onTalkdownSuccessful()
      if (this.statusSendSiteTTS == 'failed') this.onTalkdownFailed()
    },
  },
  created: function () {
    this.checkTalkdownStatus()
  },
  methods: {
    onTalkdownRequested: function () {
      this.isTalkdownSending = true
    },
    onTalkdownSuccessful: async function () {
      await this.$tool.wait(300) // Too fast
      this.isSuccessSending = true
      await this.$tool.wait(800) // For show animation
      this.isSuccessSending = false
      this.isTalkdownSending = false
    },
    onTalkdownFailed: async function () {
      await this.$tool.wait(300) // Too fast
      this.isFailedSending = true
      await this.$tool.wait(800) // For show animation
      this.isFailedSending = false
      this.isTalkdownSending = false
    },
    checkTalkdownStatus: function () {
      if (this.statusSendSiteTTS == 'requested') this.isTalkdownSending = true
      else this.isTalkdownSending = false
    },
  }
}
</script>

<style scoped>
.broadcast-status {
  visibility: hidden;
  position: fixed;
  left: 0;
  right: 0;
  bottom: calc(16px + var(--ion-safe-area-bottom, 0px));
  display: flex;
  justify-content: center;
  align-items: center;
  height: 44px;
  /* Ionic 오버레이(ion-modal 등)는 20000대 z-index 를 쓴다 — 모달이 열려 있어도 그 위에 보여야 한다 */
  z-index: 99999;
  /* 표시 전용. 아래 화면의 클릭을 막지 않는다 */
  pointer-events: none;
}
.broadcast-status.sending {
  /* IOS 16에서 CSS animation 그리고  visibility변경이 특정상황에 동작안하는 이슈... */
  /* 정확한 원인은 모르지만 duration을 강제로 줘서 해결*/
  visibility: visible;
  animation: sendingIn 10s;
}
.status-pill {
  background-color: black;
  color: white;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
  height: 44px;
  padding: 0 20px;
  border-radius: 22px;
  box-shadow: rgba(15, 15, 15, 0.2) 0px 4px 12px;
}
.status-pill.success {
  animation-duration: .3s;
  animation-name: colorchangesuccess;
  animation-fill-mode: forwards;
}
.status-pill.failed {
  animation-duration: .3s;
  animation-name: colorchangefailed;
  animation-fill-mode: forwards;
}
.status-spinner {
  width: 20px;
  height: 20px;
}
.status-text {
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
}

@keyframes sendingIn {
  from {
    opacity: 1;
  }
  to {
    opacity: 1;
  }
}
@keyframes colorchangesuccess {
  from {
    background-color: black;
  }
  to {
    background-color: var(--ion-color-tertiary);
  }
}
@keyframes colorchangefailed {
  from {
    background-color: black;
  }
  to {
    background-color: var(--ion-color-danger);
  }
}
</style>
